import React from 'react'
import ProjectList from '../../Compenet/ProjectList'
import { faArrowRight, faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../../App.css"


const Projects = ({ projects, onProjectClick }) => {
  return (
    <div className='max-w-7xl mx-auto px-4 py-6 '>
      <h1 className='text-4xl font-semibold mb-3 text-gray-900 dark:text-[rgb(211,219,236)]'>My Projects</h1>
      <ProjectList projects={projects} onProjectClick={onProjectClick} />

      <div className='flex items-center justify-between pt-6'>
        <Link to='/about' className="mb-4 nav-link py-2 dark:text-white text-[#111318] rounded">
          <FontAwesomeIcon icon={faArrowLeft} className='text-lg pr-1' /> About me
        </Link>
        <Link to='/contact' className="nav-link mb-4  py-2 dark:text-white text-[#111318] rounded">
        Contact me <FontAwesomeIcon icon={faArrowRight} className='text-lg pr-1' /> 
        </Link>
      </div>
    </div>
    
  )
}

export default Projects
